import { api } from '../../../shared/services/api';

export const ticketService = {
  // Fluxo por código / QR
  validateTicket: (ticketCode: string) =>
    api.get(`/participants/tickets/validate/${ticketCode}`),

  checkInTicket: (ticketCode: string, forceEnable: boolean = false) =>
    api.post('/participants/tickets/checkin', { ticketCode, forceEnable }),

  // Fluxo alternativo por CPF
  validateByCpf: (cpf: string) =>
    api.get(`/participants/tickets/validate-cpf/${cpf}`),

  checkInByCpf: (cpf: string, forceEnable: boolean = false) =>
    api.post('/participants/tickets/checkin', { cpf, forceEnable }),
};